import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getRoomCategoryByResortId, getRoomTypeByResortIdResorTypeId } from "../../../../../../../apis/property";
import { useParams } from 'react-router-dom';


const EditRoomType = ({ isOpen, onClose, selectedTypeId }) => {
  const { id } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    description: "",
    total_count: "",
    min_occupancy: "",
    max_occupancy: "",
    room_category_id: '',
    resort_id: id,
  });
  const [roomCategory, setRoomCategory] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchRoomCategory = async () => {
    try {
      const response = await getRoomCategoryByResortId(id);
      setRoomCategory(response.data);
    } catch (error) {
      console.log('Error fetching room class');
    }
  };
  useEffect(() => {
    fetchRoomCategory();
  }, []);

  useEffect(() => {
    const fetchRoomType = async () => {
      try {
        const response = await getRoomTypeByResortIdResorTypeId(id, selectedTypeId);
        setFormData({
          name: response.data.name,
          code: response.data.code,
          description: response.data.description,
          total_count: response.data.total_count,
          min_occupancy: response.data.min_occupancy,
          max_occupancy: response.data.max_occupancy,
          resort_id: id,
          room_category_id: response.data.room_category_id,
        });
      } catch (error) {
        console.log('Error fetching room class');
      }
    };

    fetchRoomType();
  }, [id, selectedTypeId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const accessToken = localStorage.getItem("accessToken");

      const response = await fetch(`${baseUrl}/resort/room/type/${selectedTypeId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast.success("Room Type Edited successfully");
        onClose()
      } else {
        toast.error("Failed to edit Room Type");
        console.error("Failed to edit Room Type");
      }
    } catch (error) {
      toast.error("Error occurred while editing Room Type");
      console.error("Error occurred while editing Room Type:", error);
    }
  };


  return (
    <div>
      <div
        className={`fixed z-10 inset-0 overflow-y-auto ${isOpen ? "block" : "hidden"
          }`}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 transition-opacity">
            <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
          &#8203;
          <div
            className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <form onSubmit={handleSubmit}>
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="">
                  <div className="mt-3">
                    <h3
                      className="text-lg leading-6 font-bold text-gray-900"
                      id="modal-headline"
                    >
                      Edit Room Type
                    </h3>
                    <div className="mt-10">
                      <div className="mb-4">
                        <label
                          htmlFor="name"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Room Type Name
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Room Type Name"
                          required
                        />
                      </div>

                      {/* Add other input fields for collecting resort data */}

                      {/* For Resort Code */}
                      <div className="mb-4">
                        <label
                          htmlFor="code"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Room Type Code
                        </label>
                        <input
                          type="text"
                          id="code"
                          name="code"
                          value={formData.code}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Room Type code"
                          required
                        />
                      </div>

                      {/* For Resort Description */}
                      <div className="mb-4">
                        <label
                          htmlFor="description"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Room Type Description
                        </label>
                        <textarea
                          id="description"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Room Type description"
                          required
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="total_count"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Total Number
                        </label>
                        <textarea
                          id="total_count"
                          name="total_count"
                          value={formData.total_count}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Total Number"
                          required
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="min_occupancy"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Minimum Occupancy
                        </label>
                        <textarea
                          id="min_occupancy"
                          name="min_occupancy"
                          value={formData.min_occupancy}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Minimum Occupancy"
                          required
                        />
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="min_occupancy"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Maximum Occupancy
                        </label>
                        <textarea
                          id="max_occupancy"
                          name="max_occupancy"
                          value={formData.max_occupancy}
                          onChange={handleChange}
                          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                          placeholder="Enter Maximum Occupancy"
                          required
                        />
                      </div>

                      <div className="mb-4">
                        <label
                          htmlFor="room_category_id"
                          className="block text-gray-700 text-sm font-bold mb-2"
                        >
                          Room Category
                        </label>
                        <select
                          id="class"
                          name="room_category_id"
                          value={formData.room_category_id}
                          onChange={handleChange}
                          className="block py-2.5 px-0 w-full text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer"
                          required
                        >
                          {roomCategory?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Add the remaining input fields similarly */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="submit"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Edit Room Type
                </button>
                <button
                  onClick={onClose}
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRoomType;
